// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Alert from "../catalyst/Alert.re.mjs";
import * as React from "react";
import * as Button from "../catalyst/Button.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

function ConfirmButton(props) {
  var onConfirmed = props.onConfirmed;
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  var handleConfirm = function (param) {
    setIsOpen(function (param) {
          return false;
        });
    onConfirmed();
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Button.Button.make, {
                      className: props.className,
                      children: props.button,
                      onClick: (function (param) {
                          setIsOpen(function (param) {
                                return true;
                              });
                        }),
                      type_: "button"
                    }),
                JsxRuntime.jsxs(Alert.Alert.make, {
                      open: match[0],
                      onClose: setIsOpen,
                      children: [
                        JsxRuntime.jsx(Alert.AlertTitle.make, {
                              children: props.title
                            }),
                        JsxRuntime.jsx(Alert.AlertDescription.make, {
                              children: props.description
                            }),
                        JsxRuntime.jsxs(Alert.AlertActions.make, {
                              children: [
                                JsxRuntime.jsx(Button.Button.make, {
                                      plain: true,
                                      children: "Cancel",
                                      onClick: (function (param) {
                                          setIsOpen(function (param) {
                                                return false;
                                              });
                                        })
                                    }),
                                JsxRuntime.jsx(Button.Button.make, {
                                      children: "Confirm",
                                      onClick: handleConfirm
                                    })
                              ]
                            })
                      ]
                    })
              ]
            });
}

var make = ConfirmButton;

export {
  make ,
}
/* Alert Not a pure module */
